import script from "./TitleH2.vue?vue&type=script&setup=true&lang=js"
export * from "./TitleH2.vue?vue&type=script&setup=true&lang=js"

import "./TitleH2.vue?vue&type=style&index=0&id=14fefc30&lang=scss&scoped=true"

import exportComponent from "/Users/rioschan/Downloads/event-2022electrolux-main/vue-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14fefc30"]])

export default __exports__